(function () {
  function setActiveTab(tab) {
    document.querySelectorAll('[data-algolia-tabs] [data-tab]').forEach((btn) => {
      const active = btn.dataset.tab === tab;
      btn.classList.toggle('is-active', active);
      if (active) {
        btn.setAttribute('aria-selected', 'true');
      } else {
        btn.removeAttribute('aria-selected');
      }
    });

    document.querySelectorAll('[data-panel]').forEach((panel) => {
      panel.hidden = panel.dataset.panel !== tab;
    });

    const url = new URL(globalThis.location.href);
    url.searchParams.set('tab', tab);
    history.replaceState({}, '', url.toString());
  }

  function moveAlgoliaBlocksIntoPanels() {
    const productsPanel = document.querySelector('[data-panel="products"]');
    const articlesPanel = document.querySelector('[data-panel="articles"]');
    if (!productsPanel || !articlesPanel) return;

    const allContainers = Array.from(
      document.querySelectorAll('[class*="instantsearch"], [class*="ais-"], [id*="instantsearch"], [data-algolia]')
    );

    if (allContainers.length < 2) return;

    const topLevel = allContainers.filter((el, idx, arr) => 
      !arr.some(other => other !== el && other.contains(el))
    );

    const [first, second] = topLevel;
    if (first) productsPanel.appendChild(first);
    if (second) articlesPanel.appendChild(second);
  }

  document.addEventListener('DOMContentLoaded', function () {
    moveAlgoliaBlocksIntoPanels();

    const root = document.querySelector('[data-algolia-tabs]');
    if (!root) return;

    const url = new URL(globalThis.location.href);
    const initial = url.searchParams.get('tab') || 'products';
    setActiveTab(initial);

    root.addEventListener('click', function (e) {
      const btn = e.target.closest('[data-tab]');
      if (!btn) return;
      setActiveTab(btn.dataset.tab);
    });
  });
})();